import { useQuery } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { communityKeys } from '../communities.keys';
import { checkForFreeZaps } from '../communities.service';
export const useCheckForFreeZaps = (enabled = true) => {
    const subdomain = getSubdomain();
    return useQuery({
        queryKey: communityKeys.checkForFreeZaps(),
        queryFn: () => checkForFreeZaps(subdomain),
        enabled,
    });
};
